import { useLogo } from "@/components/AppBar/hooks/useLogo";
import { Image } from "@/components/Image";
import { Link } from "react-router-dom";

type LogoProps = {
  className?: string;
  soloLogo?: boolean;
};

export const Logo: React.FC<LogoProps> = ({
  soloLogo = false,
  className = "flex-1",
}) => {
  const { handleClick, handlePrefetch } = useLogo();

  return (
    <div className={className}>
      <Link
        to="/"
        className={`flex h-full items-center w-max justify-start transition-all duration-150 ease-out ${
          !soloLogo ? "" : "items-center justify-center"
        }`}
        onClick={(e) => handleClick(e)}
        onMouseEnter={handlePrefetch}
      >
        <div className="relative flex items-end h-max overflow-hidden">
          {soloLogo ? (
            <Image
              src="/favicon-180x180.png"
              alt="Veltric logo"
              height={16}
              width={22}
            />
          ) : (
            /* Both variants stay in the DOM and are swapped by CSS. Picking the
               `src` from a JS read of the `dark` class meant every theme flip
               (and every account switch) fired a fresh image request, so the
               logo blinked out while the rest of the chrome had already
               changed colour. */
            <>
              <Image
                src="/images/Veltric-Logo-LightMode.png"
                alt="Veltric logo"
                height={16}
                width={70}
                className="dark:hidden"
                loading="eager"
                priority
              />
              <Image
                src="/images/Veltric-Logo-DarkMode.png"
                // Same alt as the light variant, not "": `dark:hidden` is
                // display:none, which drops the light one out of the
                // accessibility tree — an empty alt here would leave the home
                // link with no accessible name in dark mode.
                alt="Veltric logo"
                height={16}
                width={70}
                className="hidden dark:block"
                loading="eager"
                priority
              />
            </>
          )}
        </div>
      </Link>
    </div>
  );
};
